import './Profile.scss';

import React, { useState } from 'react';
import { generatePath, useNavigate } from 'react-router-dom';

import Button, { ButtonStyle } from '@components/Button';
import { RoutePath } from '@constants/route-path';
import { IUser } from '@models/user';
import { doSignOut } from '../../firebase/auth';

interface IProps {
  user: IUser;
  popupStatus: boolean;
  callback: () => void;
}

function Profile({ user, popupStatus, callback }: IProps) {
  const navigate = useNavigate();

  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await doSignOut();
      setError(null);
      navigate(RoutePath.LoginPage);
    } catch (err) {
      setError('Failed to sign out.');
    }
  };

  return (
    <div>
      <button className="modProfile" onClick={callback}>
        <div className="modProfile__avatar">
          {user.firstName[0]}
          {user.lastName[0]}
        </div>
        <p className="modText modText--body2">
          {user.firstName} {user.lastName}
        </p>
        <i className="modIcon modIcon--lg modIcon--chevron-down" />
      </button>
      {popupStatus && (
        <div className="modProfile__popup">
          <p>
            <Button type="link" style={ButtonStyle.Profile} to={generatePath(RoutePath.ProfilePage)}>
              My account
            </Button>
          </p>
          {/* TODO: Add company profile */}
          {/* <p>
            <button className="modProfile__blue-button">Company Profile</button>
          </p> */}
          <hr className="modProfile__separator" />
          <form onSubmit={handleSubmit}>
            <button className="modProfile__red-button">Sign out</button>
            {error && <p style={{ color: 'red' }}>{error}</p>}
          </form>
        </div>
      )}
    </div>
  );
}

export default Profile;
